import { TextInput, Textarea, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import { Group } from "../../../services/admin/groups.service";
import { required, scrollToFirstError } from "../../../utils/formValidation";

export interface GroupFormValues {
  name: string;
  description: string;
}

interface GroupFormProps {
  initialValues?: Group;
  onSubmit: (values: GroupFormValues) => void;
  isLoading?: boolean;
}

export default function GroupForm({
  initialValues,
  onSubmit,
  isLoading,
}: GroupFormProps) {
  const form = useForm<GroupFormValues>({
    initialValues: {
      name: initialValues?.name || "",
      description: initialValues?.description || "",
    },
    validate: {
      name: required("Group name is required"),
    },
  });

  // Reset form when initialValues change (e.g., when editing different group)
  useEffect(() => {
    form.setValues({
      name: initialValues?.name || "",
      description: initialValues?.description || "",
    });
    form.clearErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues?.id]);

  const handleSubmit = form.onSubmit(
    (values) => onSubmit(values),
    () => scrollToFirstError(form)
  );

  return (
    <form noValidate onSubmit={handleSubmit}>
      <Stack gap="md">
        <TextInput
          label="Group Name"
          placeholder="e.g., Administrators, Lab Staff, Pathologists"
          withAsterisk
          disabled={isLoading}
          {...form.getInputProps("name")}
        />

        <Textarea
          label="Description"
          placeholder="Enter group description and purpose"
          minRows={3}
          disabled={isLoading}
          {...form.getInputProps("description")}
        />
      </Stack>
    </form>
  );
}

export { useForm } from "@mantine/form";
